export const scrollOffsetTop = (ref, callback) => {
    //  获取窗口滚动条高度
    let scrollHeight = getScrollOffsetTop();

    // 获取浏览器可视区的高度
    let clientHeight = getClientHeight();

    if (scrollHeight + clientHeight > ref.offsetTop) {
        callback()
    }
}

export const getScrollOffsetTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
}

export const getClientHeight = () => {
    return document.documentElement.clientHeight || document.body.clientHeight;
}